import RestResource from '../rest.service';

export default class CampaignDatesService extends RestResource {
  map(payload) {
    return {
      date: payload.date,
      detail: payload.detail,
      campaign_id: payload.campaign,
    };
  }

  constructor() {
    super('campaigns-dates');
  }
}
